import React, { useState, useEffect } from "react";
import {formatDate, renderRatingStars, renderResellerBadge, searchContent} from '../../utils/utilsHelpers';
import TableComponent from '../bootstrap/TableComponent';
import Image from "react-bootstrap/Image";
import {isDesktop} from "react-device-detect";
import Button from "react-bootstrap/Button";

const reviewContentLength = 150;

export default function ReviewTableList(props) {

    let { reviews, searchValue, selectedFilters} = props;

    // Also in props: sortDataViaKey, tagQuotesHandler

    const renderReviewContent = ({title, body, strategic_themes}) => {
        if (searchValue) {
            let searchTxt = Object.values(body).find((bodySection) => bodySection.toLowerCase().includes(searchValue.toLowerCase()))
            return searchContent(searchTxt, reviewContentLength, searchValue);
        } else if ('strategic_themes' in selectedFilters.dropdown) {
            // if a strategic theme is selected in the filters, display all the quotes for that theme in the Content column
            // Sample strategic_themes data:
            // [
            //     [
            //         "Types of Systems",
            //         "Rubrik is our primary backup solution for production and development systems..."
            //     ],
            //     [
            //         "Web Interface",
            //         "The Rubrik web interface is really easy to use. "
            //     ],
            //     [
            //         "SLA-Based Policy Automation ",
            //         "SLA-based policy automation is easy to use and easy to customize..."
            //     ]
            //  ]
            let quotes = selectedFilters.dropdown.strategic_themes.flatMap((filterName) => {
                return strategic_themes.filter(arr => arr[0] == filterName).map(arr => arr[1])
            });
            return (
                quotes.map((q, i) => {
                    return (
                        <p className={`pt-2 ${i > 0 && 'border-top'}`} key={i}>{q}</p>
                    )
                })
            )
        }

        return searchContent(title, reviewContentLength, searchValue);
    }


    // Render table headers
    const tableHeaders = () => {
        return (
            <tr className={'sortable'}>
                <th data-sortable={false}></th>
                <th data-sortable={false}>Author</th>
                {/* <th onClick={() => props.sortDataViaKey('industry')}>Industry</th>
                <th onClick={() => props.sortDataViaKey('company_size_key')}>Company Size</th> */}
                <th onClick={() => props.sortDataViaKeyHandler('rating')}>Rating</th>
                <th className={'text-center text-nowrap'} onClick={() => props.sortDataViaKeyHandler('word_count')}>Word Count</th>
                <th className={'text-nowrap'} onClick={() => props.sortDataViaKeyHandler('published_date')}>Published Date</th>
                <th data-sortable={false}>Content</th>
                <th className={'text-center'} data-sortable={false}>Actions</th>
            </tr>
        )
    }

    // Render table rows
    const tableRows = () => {
        return (
            reviews && reviews.map((review, index) => {
                return (
                    <tr key={index}>
                        <td>
                            <Image roundedCircle className={'me-2'} width={60} src={review.avatar}></Image>
                        </td>
                        <td>
                            <span className={'d-flex fw-bold'}>{review.name}</span>
                            <span className={'d-flex font-12'}>{review.job_title}</span>
                            <span className={'d-flex font-12'}>{review.company}</span>
                            <div className={'mt-2'}></div>
                            <span className={'d-flex font-12'}>{review.industry}</span>
                            <span className={'d-flex font-12'}>{review.company_size}</span>
                        </td>
                        <td>{review.reseller ? renderResellerBadge() : renderRatingStars(review.rating)}</td>
                        <td className={'text-center'}>{review.word_count}</td>
                        <td className={'text-center text-nowrap'}>{formatDate(review.published_date)}</td>
                        <td style={{width: '35%'}}>
                            {renderReviewContent(review)}
                        </td>
                        <td className={'text-center'}>
                            <>
                                {
                                    isDesktop &&
                                    <Button variant="success" size="xs" className={'toggle-slidebar mb-1 text-nowrap text-white'} onClick={() => props.tagQuotesHandler(review)}>
                                        Tag Quotes
                                    </Button>
                                }

                                <div className={'d-flex justify-content-center'}>
                                    <a href={review.actions.pdf} target={'_blank'} rel={'noopener noreferrer'}>
                                        <i className={"fas fa-download me-1 text-secondary"} />
                                    </a>
                                    <a href={review.actions.url} target={'_blank'} rel={'noopener noreferrer'}>
                                        <i className={"fas fa-external-link-square-alt text-secondary"} />
                                    </a>
                                </div>
                            </>
                        </td>
                    </tr>
                )
            })
        )
    }

    return (
        <TableComponent
            tableHeaders={tableHeaders()}
            tableRows={tableRows()}
            isCentered='true'
            isStriped={true}
        />
    )
}